var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Flex } from '@chakra-ui/react';
import { useRadioGroupContextForItem } from './RadioGroup';
export var RadioCard = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var _b = useRadioGroupContextForItem(props), inputProps = _b.inputProps, checkboxProps = _b.checkboxProps, labelProps = _b.labelProps, _c = _b.state, isDisabled = _c.isDisabled, isChecked = _c.isChecked, hideUnselected = _c.hideUnselected;
    if (hideUnselected && !isChecked) {
        return null;
    }
    return (_jsxs(Box, __assign({ as: "label" }, labelProps, { my: 2, width: "100%" }, { children: [_jsx("input", __assign({}, inputProps), void 0), _jsx(Box, __assign({}, checkboxProps, { minH: "180px", cursor: isDisabled ? 'inherit' : 'pointer', borderWidth: "1px", borderRadius: "md", boxShadow: "sm", _checked: {
                    borderColor: 'brand.blue',
                }, px: 5, py: 3 }, { children: _jsxs(Flex, __assign({ align: "center" }, { children: [_jsx(Box, { height: "20px", width: "20px", minWidth: "20px", backgroundColor: isChecked ? 'brand.blue' : 'brand.dark-gray', borderColor: "brand.dark-gray", borderWidth: isChecked ? '3px' : '1px', borderRadius: "50%", mx: 3 }, void 0), children] }), void 0) }), void 0)] }), void 0));
};
